import { render, staticRenderFns } from "./ButtonSearch.vue?vue&type=template&id=f4c9867a&"
import script from "./ButtonSearch.vue?vue&type=script&lang=js&"
export * from "./ButtonSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports